import { ThunkAction } from 'redux-thunk';
import { NewMedicine } from '../../api/answerSnackingQuestions';
import { DFormEntity } from '../../api/fetchDoctorGenieByOID';
import {
    CalculatorsConfig,
    ExtraFlags,
    GenieSettings,
    IClaimableAmount,
    MedicalHistoryConfig,
    VitalsConfig,
} from '../../api/pushGenie';
import { GDyForm, SectionNameConfig } from '../db';
import { Patient } from '../types/patient';
import { DocProfileResponse } from '../../api/fetchDoctorProfile';
import { GlobalState } from '../reducers';
import { UpdateMyProfileAction, fetchMyGenie, updateMyProfile } from './login';
import { batch } from 'react-redux';
import { MHC } from '../types/medicalHistory';
import fetchMyProfile from '../../api/fetchMyProfile';
import { CareCanvas } from '../types/CareCanvas';
import { getMyGroupAccessId } from '../localstorage';
import { Actions } from '.';
import fetchUHIDConfig from '../../api/fetchUHIDConfig';

export const TOGGLE_PRINT_PREVIEW = 'TOGGLE_PRINT_PREVIEW';
export const SET_PREVIEW_DIRTY = 'SET_PREVIEW_DIRTY';
export const REFRESH_ALL_PATIENTS = 'REFRESH_ALL_PATIENTS';

export const TOGGLE_PRIVACY_DIALOG = 'SHOW_PRIVACY_DIALOG';
export const TOGGLE_GOOGLE_REVIEW_DIALOG = 'TOGGLE_GOOGLE_REVIEW_DIALOG';
export const TOGGLE_SHOW_EKA_COMM = 'TOGGLE_SHOW_EKA_COMM';
export const TOGGLE_GLOBAL_SEARCH = 'TOGGLE_GLOBAL_SEARCH';
export const TOGGLE_NEW_PT_DIALOG = 'TOGGLE_NEW_PT_DIALOG';
export const TOGGLE_STORAGE_MODAL = 'TOGGLE_STORAGE_MODAL';
export const TOGGLE_IFRAME_DIALOG = 'TOGGLE_IFRAME_DIALOG';

export const SET_EDIT_PATIENT = 'SET_EDIT_PATIENT';

export const SETUP_SETTINGS = 'SETUP_SETTINGS';

export const UPDATE_GENIE_SETTINGS = 'UPDATE_GENIE_SETTINGS';
export const UPSERT_GENIE_SETTINGS = 'UPSERT_GENIE_SETTINGS';
export const UPSERT_MEDICAL_HISTORY_CONFIG = 'UPSERT_MEDICAL_HISTORY_CONFIG';
export const LOAD_PAD_DY_FORM = 'LOAD_PAD_DY_FORM';
export const UPSERT_VITALS_CONFIG = 'UPSERT_VITALS_CONFIG';
export const UPSERT_CALCULATOR_CONFIG = 'UPSERT_CALCULATOR_CONFIG';
export const LOAD_CALCULATOR_CONFIG = 'LOAD_CALCULATOR_CONFIG';
export const LOAD_SECTION_NAME_CONFIG = 'LOAD_SECTION_NAME_CONFIG';
export const UPSERT_SECTION_NAME_CONFIG = 'UPSERT_SECTION_NAME_CONFIG';
export const LOAD_VITALS_CONFIG = 'LOAD_VITALS_CONFIG';
export const UPDATE_ADD_PT_DY_FORM = 'UPDATE_ADD_PT_DY_FORM';
export const FETCH_SNACKING_QUESTIONS = 'FETCH_SNACKING_QUESTIONS';
export const ANSWER_SNACKING_QUESTION = 'ANSWER_SNACKING_QUESTION';
export const UPDATE_STAR_VITALS = 'UPDATE_STAR_VITALS';
export const SET_KHATA_CREDITS = 'SET_KHATA_CREDITS';
export const SET_EXTRA_FLAGS = 'SET_EXTRA_FLAGS';
export const UPDATE_CLAIMABLE_AMOUNT = 'UPDATE_CLAIMABLE_AMOUNT';
export const SET_PINCODE = 'SET_PINCODE';
export const SET_ACTIVE_ORDER_UPDATES_COUNT = 'SET_ACTIVE_ORDER_UPDATES_COUNT';
export const SET_IS_NOTES_MODE = 'SET_IS_NOTES_MODE';
export const SET_DONT_ALLOW_START_VISIT = 'SET_DONT_ALLOW_START_VISIT';
export const SET_IS_TREATMENT_PLAN_ENABLED = 'SET_IS_TREATMENT_PLAN_ENABLED';
export const SET_IS_DICOM_ENABLED = 'SET_IS_DICOM_ENABLED';
export const SET_CARE_CANVAS_PREVIEW = 'SET_CARE_CANVAS_PREVIEW';
export const TOGGLE_LOGOUT_MODAL = 'TOGGLE_LOGOUT_MODAL';
export const SET_BUSINESS_UHID_PREFIX = 'SET_BUSINESS_UHID_PREFIX';
export const SET_GLOBAL_SEARCH_FLAG = 'SET_GLOBAL_SEARCH_FLAG';

export type SessionActions =
    | SetPreviewDirtyAction
    | TogglePrivacyDialogAction
    | ToggleGoogleReviewDialogAction
    | ToggleShowEkaCommAction
    | ToggleNewPtDialogAction
    | SetEditPatient
    | ToggleIframeDialogAction
    | UpdateGenieSettingAction
    | UpsertGenieSettingAction
    | UpsertMedicalHistoryConfigAction
    | LoadPadDyFormAction
    | UpsertVitalsConfigAction
    | UpsertCalculatorConfigAction
    | LoadCalculatorConfigAction
    | UpsertSectionNameConfigAction
    | LoadSectionNameConfigAction
    | LoadVitalsConfigAction
    | UpdateAddPtDyFormAction
    | SetUpSettings
    | FetchSnackingQuestionsAction
    | AnswerSnackingQuestionAction
    | RefreshAllPatients
    | ToggleGlobalSearchAction
    | UpdateStarVitalsAction
    | SetKhataCreditsAction
    | SetExtraFlagsAction
    | ToggleStorageModalAction
    | SetPincodeAction
    | SetActiveOrderUpdatesCountAction
    | UpdateClaimableAmountAction
    | SetDontAllowStartVisit
    | SetIsNotesMode
    | SetIsTreatmentPlanEnabledAction
    | SetIsDicomEnabledAction
    | SetCareCanvasPreview
    | ToggleLogoutModal
    | SetBusinessUhidPrefix
    | SetGlobalSearchFlag;

export interface SetPreviewDirtyAction {
    type: typeof SET_PREVIEW_DIRTY;
    isPrintPreview: boolean;
}

export const setPreviewDirty = (isPrintPreview: boolean): SetPreviewDirtyAction => {
    return { type: SET_PREVIEW_DIRTY, isPrintPreview };
};

export interface UpdateStarVitalsAction {
    type: typeof UPDATE_STAR_VITALS;
    data: string[];
}

export const starKeyVital = (data: string[]): UpdateStarVitalsAction => {
    return { type: UPDATE_STAR_VITALS, data };
};

export interface TogglePrivacyDialogAction {
    type: typeof TOGGLE_PRIVACY_DIALOG;
    isVisible: boolean;
}

export const togglePrivacyDialog = (isVisible: boolean): TogglePrivacyDialogAction => {
    return { type: TOGGLE_PRIVACY_DIALOG, isVisible };
};

export interface ToggleGoogleReviewDialogAction {
    type: typeof TOGGLE_GOOGLE_REVIEW_DIALOG;
    isGoogleReviewDialogVisible?: string;
}

export const toggleGoogleReviewDialog = (
    isGoogleReviewDialogVisible?: string,
): ToggleGoogleReviewDialogAction => {
    return { type: TOGGLE_GOOGLE_REVIEW_DIALOG, isGoogleReviewDialogVisible };
};

export interface ToggleShowEkaCommAction {
    type: typeof TOGGLE_SHOW_EKA_COMM;
    showEkaCommunications: boolean;
}

export const toggleShowEkaCommDialog = (
    showEkaCommunications: boolean,
): ToggleShowEkaCommAction => {
    return { type: TOGGLE_SHOW_EKA_COMM, showEkaCommunications };
};

export interface ToggleGlobalSearchAction {
    type: typeof TOGGLE_GLOBAL_SEARCH;
    isGlobalSearchVisible: boolean;
}

export const toggleGlobalSearch = (isGlobalSearchVisible: boolean): ToggleGlobalSearchAction => {
    return { type: TOGGLE_GLOBAL_SEARCH, isGlobalSearchVisible };
};

export interface ToggleStorageModalAction {
    type: typeof TOGGLE_STORAGE_MODAL;
    isStorageModalVisible: boolean;
}

export const toggleStorageModal = (isStorageModalVisible: boolean): ToggleStorageModalAction => {
    return { type: TOGGLE_STORAGE_MODAL, isStorageModalVisible };
};

export interface ToggleNewPtDialogAction {
    type: typeof TOGGLE_NEW_PT_DIALOG;
    isNewPatientDialogVisisble: boolean;
}

export const toggleNewPtDialog = (isNewPatientDialogVisisble: boolean): ToggleNewPtDialogAction => {
    return { type: TOGGLE_NEW_PT_DIALOG, isNewPatientDialogVisisble };
};

export interface ToggleIframeDialogAction {
    type: typeof TOGGLE_IFRAME_DIALOG;
    url?: string;
}

export const toggleIframeActionDialog = (url?: string): ToggleIframeDialogAction => {
    return { type: TOGGLE_IFRAME_DIALOG, url };
};

export interface RefreshAllPatients {
    type: typeof REFRESH_ALL_PATIENTS;
}

export const refreshAllPatients = (): RefreshAllPatients => {
    return { type: REFRESH_ALL_PATIENTS };
};

export interface SetUpSettings {
    type: typeof SETUP_SETTINGS;
    settings: GenieSettings;
}

export const setSetupSettings = (settings: GenieSettings): SetUpSettings => {
    return { type: SETUP_SETTINGS, settings };
};

export interface SetEditPatient {
    type: typeof SET_EDIT_PATIENT;
    patient?: Patient;
    ptMedicalHistory?: MHC;
}

export const setEditPatient = (patient?: Patient, mh?: MHC): SetEditPatient => {
    return { type: SET_EDIT_PATIENT, patient, ptMedicalHistory: mh };
};

/**
 * @deprecated use upsertGenieSetting
 */
export interface UpdateGenieSettingAction {
    type: typeof UPDATE_GENIE_SETTINGS;
    key: keyof GenieSettings;
    value: boolean;
}

/**
 * @deprecated use upsertGenieSetting
 */
export const updateGenieSetting = (
    key: keyof GenieSettings,
    value: boolean,
): UpdateGenieSettingAction => {
    return { type: UPDATE_GENIE_SETTINGS, key, value };
};

export interface UpsertGenieSettingAction {
    type: typeof UPSERT_GENIE_SETTINGS;
    setting: Partial<GenieSettings>;
    oid?: string;
}

export const upsertGenieSetting = (
    setting: Partial<GenieSettings>,
    oid?: string,
): UpsertGenieSettingAction => {
    return { type: UPSERT_GENIE_SETTINGS, setting, oid };
};

export interface UpsertMedicalHistoryConfigAction {
    type: typeof UPSERT_MEDICAL_HISTORY_CONFIG;
    medicalHistoryConfig: MedicalHistoryConfig;
    oid: string;
}

export const upsertMedicalHistoryConfig = (
    medicalHistoryConfig: MedicalHistoryConfig,
    oid: string,
): UpsertMedicalHistoryConfigAction => {
    return { type: UPSERT_MEDICAL_HISTORY_CONFIG, medicalHistoryConfig, oid };
};

export interface LoadPadDyFormAction {
    type: typeof LOAD_PAD_DY_FORM;
    padDyForm: GDyForm[];
}

export const loadPadDyForm = (padDyForm: GDyForm[]): LoadPadDyFormAction => {
    return { type: LOAD_PAD_DY_FORM, padDyForm };
};

export interface UpsertVitalsConfigAction {
    type: typeof UPSERT_VITALS_CONFIG;
    vitalsConfig: VitalsConfig;
}

export const upsertVitalsConfig = (vitalsConfig: VitalsConfig): UpsertVitalsConfigAction => {
    return { type: UPSERT_VITALS_CONFIG, vitalsConfig };
};

export interface SetBusinessUhidPrefix {
    type: typeof SET_BUSINESS_UHID_PREFIX;
    prefix: string;
}

export const setBusinessUhidPrefix = (prefix: string): SetBusinessUhidPrefix => ({
    type: SET_BUSINESS_UHID_PREFIX,
    prefix,
});

/**
 * @deprecated use fetchDoc
 */
export const fetchDocWithRefresh = (
    docOID: string,
    onSuccess?: () => void,
    onFailure?: () => void,
): ThunkAction<
    Promise<DocProfileResponse | void>,
    GlobalState,
    null,
    UpdateMyProfileAction | RefreshAllPatients
> => {
    return async (dispatch): Promise<DocProfileResponse | void> => {
        return fetchMyProfile(getMyGroupAccessId())
            .then((value) => {
                batch(async () => {
                    dispatch(updateMyProfile(value));
                    if (value?.doctor?._id) {
                        dispatch(
                            fetchMyGenie(undefined, undefined, onSuccess, onFailure, value.roles),
                        );
                    }
                });
            })
            .catch((e) => {
                console.error('fetchDoctorByOID =>', e);
                if (onFailure) {
                    onFailure();
                }
            })
            .finally(() => dispatch(refreshAllPatients()));
    };
};

export interface UpsertCalculatorConfigAction {
    type: typeof UPSERT_CALCULATOR_CONFIG;
    calculatorConfig: CalculatorsConfig;
}

export const upsertCalculatorConfig = (
    calculatorConfig: CalculatorsConfig,
): UpsertCalculatorConfigAction => {
    return { type: UPSERT_CALCULATOR_CONFIG, calculatorConfig };
};

export interface LoadCalculatorConfigAction {
    type: typeof LOAD_CALCULATOR_CONFIG;
    calculatorConfig: CalculatorsConfig;
}

export const loadCalculatorConfig = (
    calculatorConfig: CalculatorsConfig,
): LoadCalculatorConfigAction => {
    return { type: LOAD_CALCULATOR_CONFIG, calculatorConfig };
};

export interface UpsertSectionNameConfigAction {
    type: typeof UPSERT_SECTION_NAME_CONFIG;
    sectionNameConfig: SectionNameConfig;
    oid: string;
}

export const upsertSectionNameConfig = (
    sectionNameConfig: SectionNameConfig,
    oid: string,
): UpsertSectionNameConfigAction => {
    return { type: UPSERT_SECTION_NAME_CONFIG, sectionNameConfig, oid };
};

export interface LoadSectionNameConfigAction {
    type: typeof LOAD_SECTION_NAME_CONFIG;
    sectionNameConfig: SectionNameConfig;
}

export const loadSectionNameConfig = (
    sectionNameConfig: SectionNameConfig,
): LoadSectionNameConfigAction => {
    return { type: LOAD_SECTION_NAME_CONFIG, sectionNameConfig };
};

export interface LoadVitalsConfigAction {
    type: typeof LOAD_VITALS_CONFIG;
    vitalsConfig: VitalsConfig;
}

export const fetchSnackingQuestions = (onSuccess?: () => void): FetchSnackingQuestionsAction => {
    return { type: FETCH_SNACKING_QUESTIONS, onSuccess };
};

export interface FetchSnackingQuestionsAction {
    type: typeof FETCH_SNACKING_QUESTIONS;
    onSuccess?: () => void;
}

export const answerSnackingQuestion = (
    newMed: NewMedicine | NewMedicine[],
    q_id?: string,
    setIsUpdateGenieLoading?: () => void,
    setIsFetchingQuestions?: () => void,
    isLast?: boolean,
    skipPushToBE?: boolean,
    version?: string,
): AnswerSnackingQuestionAction => {
    return {
        type: ANSWER_SNACKING_QUESTION,
        newMed,
        q_id,
        setIsUpdateGenieLoading,
        setIsFetchingQuestions,
        isLast,
        skipPushToBE,
        version,
    };
};

export interface AnswerSnackingQuestionAction {
    type: typeof ANSWER_SNACKING_QUESTION;
    newMed: NewMedicine | NewMedicine[];
    q_id?: string;
    setIsUpdateGenieLoading?: () => void;
    setIsFetchingQuestions?: () => void;
    isLast?: boolean;
    skipPushToBE?: boolean;
    version?: string;
}

export const loadVitalsConfig = (vitalsConfig: VitalsConfig): LoadVitalsConfigAction => {
    return { type: LOAD_VITALS_CONFIG, vitalsConfig };
};

export interface UpdateAddPtDyFormAction {
    type: typeof UPDATE_ADD_PT_DY_FORM;
    data: DFormEntity[];
}

export const updateAddPtDyForm = (data: DFormEntity[]): UpdateAddPtDyFormAction => {
    return { type: UPDATE_ADD_PT_DY_FORM, data };
};

export interface SetKhataCreditsAction {
    type: typeof SET_KHATA_CREDITS;
    khataCredits: number;
}

export const setKhataCredits = (khataCredits: number): SetKhataCreditsAction => {
    return { type: SET_KHATA_CREDITS, khataCredits };
};

export interface SetExtraFlagsAction {
    type: typeof SET_EXTRA_FLAGS;
    extraFlags: ExtraFlags;
}

export const setExtraFlags = (extraFlags: ExtraFlags): SetExtraFlagsAction => {
    return { type: SET_EXTRA_FLAGS, extraFlags };
};

export interface UpdateClaimableAmountAction {
    type: typeof UPDATE_CLAIMABLE_AMOUNT;
    claimableAmount: IClaimableAmount[] | undefined;
}

export const updateClaimableAmountFlags = (
    claimableAmount: IClaimableAmount[] | undefined,
): UpdateClaimableAmountAction => {
    return { type: UPDATE_CLAIMABLE_AMOUNT, claimableAmount };
};

export interface SetPincodeAction {
    type: typeof SET_PINCODE;
    pincode: string;
}

export const setPincode = (pincode: string): SetPincodeAction => {
    return { type: SET_PINCODE, pincode };
};

export interface SetActiveOrderUpdatesCountAction {
    type: typeof SET_ACTIVE_ORDER_UPDATES_COUNT;
    activeOrderUpdatesCount: number;
}

export const setActiveOrderUpdatesCount = (
    activeOrderUpdatesCount: number,
): SetActiveOrderUpdatesCountAction => {
    return { type: SET_ACTIVE_ORDER_UPDATES_COUNT, activeOrderUpdatesCount };
};

export const setIsNotesMode = (isNotesMode: boolean | undefined): SetIsNotesMode => {
    return { type: SET_IS_NOTES_MODE, isNotesMode };
};

export interface SetIsNotesMode {
    type: typeof SET_IS_NOTES_MODE;
    isNotesMode: boolean | undefined;
}

export const setDontAllowStartVisit = (
    dontAllowStartVisit: boolean | undefined,
): SetDontAllowStartVisit => {
    return { type: SET_DONT_ALLOW_START_VISIT, dontAllowStartVisit };
};

export interface SetDontAllowStartVisit {
    type: typeof SET_DONT_ALLOW_START_VISIT;
    dontAllowStartVisit: boolean | undefined;
}

export interface SetIsTreatmentPlanEnabledAction {
    type: typeof SET_IS_TREATMENT_PLAN_ENABLED;
    isTreatmentPlanEnabled?: boolean;
}

export const setIsTreatmentPlanEnabled = (
    isTreatmentPlanEnabled?: boolean,
): SetIsTreatmentPlanEnabledAction => {
    return { type: SET_IS_TREATMENT_PLAN_ENABLED, isTreatmentPlanEnabled };
};

export interface SetIsDicomEnabledAction {
    type: typeof SET_IS_DICOM_ENABLED;
    isDicomEnabled?: boolean;
}

export const setIsDicomEnabled = (isDicomEnabled?: boolean): SetIsDicomEnabledAction => {
    return { type: SET_IS_DICOM_ENABLED, isDicomEnabled };
};

export interface SetCareCanvasPreview {
    type: typeof SET_CARE_CANVAS_PREVIEW;
    careCanvasPreview?: CareCanvas;
}

export const setCareCanvasPreview = (careCanvasPreview?: CareCanvas): SetCareCanvasPreview => {
    return { type: SET_CARE_CANVAS_PREVIEW, careCanvasPreview };
};

export interface ToggleLogoutModal {
    type: typeof TOGGLE_LOGOUT_MODAL;
    showLogoutModal?: boolean;
}

export const toggleLogoutModal = (showLogoutModal?: boolean): ToggleLogoutModal => {
    return { type: TOGGLE_LOGOUT_MODAL, showLogoutModal };
};

export interface SetGlobalSearchFlag {
    type: typeof SET_GLOBAL_SEARCH_FLAG;
    enableBEGlobalSearch: boolean;
}

export const setGlobalSearchFlag = (enableBEGlobalSearch: boolean): SetGlobalSearchFlag => {
    return { type: SET_GLOBAL_SEARCH_FLAG, enableBEGlobalSearch };
};

export const fetchAndStoreUhidPrefix = (): ThunkAction<
    Promise<void>,
    GlobalState,
    null,
    Actions
> => {
    return async (dispatch): Promise<void> => {
        try {
            const t = await fetchUHIDConfig();
            if (t.success) {
                dispatch(setBusinessUhidPrefix(t.config.prefix));
            }
        } catch (e) {
            console.error('fetching UHID Prefix=>', e);
        }
    };
};
